/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../../panther/components/base/BaseComponent';

import styles from './ContactCardChannel.css';

class ContactCardChannel extends BaseComponent {
    constructor() {
        super();
    }

    render() {
        let content = this.getChannelByType(this.props.type);

        return (
            <div className="contact-card-channel">
                {content}
            </div>
        );
    }

    getChannelByType(type){
        let body = null;
        let icon = null;

        switch (type) {
            case "website":
                body = (
                    <div key={type + "-body"} className="channel-body">
                        <p><a title={this.props.address} target="_blank" href={"http://" + this.props.address}>{this.props.address}</a></p>
                    </div>
                );
                icon = (
                    <div key={type + "-icon"} className="channel-icon">
                        <i className="fa fa-globe"></i>
                    </div>
                );
                break;
            case "e-mail":
                body = (
                    <div key={type + "-body"} className="channel-body">
                        <p><a title={this.props.address} href={"mailto:" + this.props.address}>{this.props.addressDisplay}</a></p>
                    </div>
                );
                icon = (
                    <div key={type + "-icon"} className="channel-icon">
                        <i className="fa fa-envelope-open-o"></i>
                    </div>
                );
                break;
            case "phone":
                body = (
                    <div key={type + "-body"} className="channel-body">
                        <p><a href={"tel:" + this.props.address}>{this.props.address}</a></p>
                    </div>
                );
                icon = (
                    <div key={type + "-icon"} className="channel-icon">
                        <i className="fa fa-phone"></i>
                    </div>
                );
                break;
            case "location":
                let address = [];
                this.props.address.map((item,index) => {
                    address.push(<p key={"contact-card-loc-address-" + index}>{item}</p>);
                    return address;
                });
                body = (
                    <div key={type + "-body"} className="channel-body">
                        <address>{address}</address>
                    </div>
                );
                icon = (
                    <div key={type + "-icon"} className="channel-icon">
                        <i className="fa fa-map-marker"></i>
                    </div>
                );
                break;
            default:
        }
        return [icon, body];
    }
}

ContactCardChannel.propTypes = {
    type: PropTypes.string,
    addressDisplay: PropTypes.string,
};

export default ContactCardChannel;